<script lang="ts">
    
    import type { CoordinatesDto, MilestoneDto } from "../../global";
    import { calcDistance, playerPosition } from "../../Services/geolocation";
    import { uploadPicture } from "../../Services/pictures";
    import { currentUser } from "../../Services/user";
    import IconCamera from "../Shared/IconCamera.svelte";

    export let milestone: MilestoneDto;

    let input: HTMLInputElement;
    let isUploading = false;
    let isClose = false;

    $: isClose = checkIsClose(milestone, $playerPosition);

    function checkIsClose(milestone: MilestoneDto, playerPosition: CoordinatesDto): boolean {
        if (!playerPosition) {
            return false;
        }
        return calcDistance(playerPosition, milestone.position) < 20;
    }

    function onClick(): void {
        if (isUploading || !isClose) {
            return;
        }
        input?.click();
    }

    async function onChange(): Promise<void> {
        const file = input.files[0];
        input.value = '';

        if (!file) {
            return;
        }

        try {
            isUploading = true;
            await uploadPicture(file, milestone.id);
        } catch (error) {
            console.error(error);
        } finally {
            isUploading = false;
        }
    }

</script>

{#if $currentUser}
    <input type="file" style="display: none;" on:change={onChange} bind:this={input}>

    <button
        type="button"
        class="picture-upload-btn"
        class:is-close={isClose}
        on:click={onClick}
        disabled={isUploading || !isClose}>
        <IconCamera /><div class="text">{isClose ? 'Capturar' : 'Estás muy lejos'}</div>
    </button>
{/if}

<style lang="scss">

    .picture-upload-btn {
        color: #fff;
        border: none;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background-color: var(--color-primary);
        border-radius: 4px;

        &:disabled {
            filter: grayscale(1);
        }
    }

</style>
